import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ServiceDefinition } from '@wix/services-manager/types'
import { TranslationsDefinition } from '@wix/viewer-service-translations/definition'
import type {
	ITranslationsService,
	ITranslationsServiceConfig,
	ITranslationsServiceDefinition,
} from '@wix/viewer-service-translations/definition'
import { TranslationsService as impl } from '@wix/viewer-service-translations/implementations'
import type { TranslationsServicePageConfig } from './types'
import { name } from './symbols'

const definition: ServiceDefinition<ITranslationsService, ITranslationsServiceConfig> = TranslationsDefinition

export const translationsService = withDependencies(
	[named(PageFeatureConfigSymbol, name)],
	(pageFeatureConfig: TranslationsServicePageConfig): ServiceProvider<ITranslationsServiceDefinition, typeof impl> => {
		return {
			definition,
			impl,
			// TODO: change to {} when specs.thunderbolt.takeTranslationsFromManifest is merged
			config: pageFeatureConfig as unknown as ITranslationsServiceConfig,
			platformConfig: pageFeatureConfig,
		}
	}
)
